import { render, staticRenderFns } from "./PlaceholderSize.vue?vue&type=template&id=15345187"
import script from "./PlaceholderSize.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlaceholderSize.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports